import { ReturnOriginRemapChange } from '@/console/api/types'
import { ConfirmDialog } from '@/console/ui/ConfirmDialog'
import { ReturnOriginRemapInput, formatChangeValues } from './originRemap'
import styles from './OriginRemap.module.css'

type OriginRemapConfirmBodyProps = {
  input: ReturnOriginRemapInput
  plannedChanges: ReturnOriginRemapChange[]
}

/** 서버는 "같은 합포 송장에 같은 상품인 다른 라인" 까지만 증명한다 — 진짜 주인은 센터 확인이 정하므로 실행 직전에 다시 묻는다. */
const OriginRemapConfirmBody = ({ input, plannedChanges }: OriginRemapConfirmBodyProps): JSX.Element => (
  <>
    <ul className={styles.dialogList}>
      <li>A 오매핑 입고실적: {input.misMappedInboundReportId}</li>
      <li>B 막힌 입고실적: {input.blockedInboundReportId}</li>
      <li>
        Y 원주문 라인: {input.correctRefNo1} / {input.correctRefNo2}
      </li>
      <li>사유: {input.reason}</li>
    </ul>
    <p className={styles.dialogText}>판정 때 받은 변경 계획</p>
    <ul className={styles.dialogList}>
      {plannedChanges.map((change) => (
        <li key={`${change.table}-${change.id}`}>
          {change.table} #{change.id}: {formatChangeValues(change.before)} → {formatChangeValues(change.after)}
        </li>
      ))}
    </ul>
    <p className={styles.dialogText}>
      <b>센터 확인을 받았나요?</b> 서버는 A 와 Y 가 같은 합포 송장에 같은 상품인 다른 라인이라는 것까지만 확인해요. A 가 정말 Y 의 반품인지는 센터
      확인으로만 정해져요.
    </p>
    <p className={styles.dialogText}>실행하면 SAP 로 나갈 ERP 반품행이 만들어지고, 같은 요청은 다시 보낼 수 없어요.</p>
  </>
)

export type OriginRemapConfirmDialogProps = OriginRemapConfirmBodyProps & { onConfirm: () => void; onCancel: () => void }

/** 열린 동안에만 렌더한다 — 판정을 통과한 입력과 계획이 있을 때만 호출부가 그린다. */
export const OriginRemapConfirmDialog = ({ input, plannedChanges, onConfirm, onCancel }: OriginRemapConfirmDialogProps): JSX.Element => (
  <ConfirmDialog
    open
    title="원주문 재매핑을 실행할까요?"
    body={<OriginRemapConfirmBody input={input} plannedChanges={plannedChanges} />}
    confirmLabel="실행"
    danger
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
)
